import React from "react";
import emptyImage from "../../images/empty.jpg";

export const getProfileImage = (user) =>
  !user?.profile_photo ? emptyImage : `${process.env.REACT_APP_IMAGES_DATA_RESOURCES_URL}/${user.profile_photo}`;

/** Round avatar with optional presence dot. `online` undefined = no dot. */
function UserAvatar({ user, size = 36, online, title }) {
  return (
    <span className='bh-avatar' style={{ width: size, height: size }} title={title}>
      <img src={getProfileImage(user)} alt='' loading='lazy' />
      {online !== undefined && (
        <span className={`bh-avatar__dot ${online ? "bh-avatar__dot--online" : ""}`} aria-hidden='true' />
      )}
    </span>
  );
}

export default UserAvatar;
